import type { MaintenanceStatus } from "@/api/settingsApi";
import { SettingsService } from "@/services/SettingsService";

/**
 * Check maintenance status using public endpoint (no auth required)
 * Used on login page to check if system is in maintenance mode
 */
export async function checkPublicMaintenanceStatus(): Promise<MaintenanceStatus> {
  const settingsService = new SettingsService();
  return settingsService.getPublicMaintenanceStatus();
}
